import { render, staticRenderFns } from "./AssessmentModePlaceholder.vue?vue&type=template&id=262dfc6e&scoped=true"
import script from "./AssessmentModePlaceholder.vue?vue&type=script&lang=js"
export * from "./AssessmentModePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./AssessmentModePlaceholder.vue?vue&type=style&index=0&id=262dfc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262dfc6e",
  null
  
)

export default component.exports